"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=inventory-movement.dto.js.map